var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{staticClass:"operator"},[(_vm.condition !== 'step' && _vm.condition !== 'a')?_c('image',{attrs:{"xlink:href":require("../assets/operators/build.svg"),"width":"15","height":1152/584*15,"transform":"translate(-22,-24)"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }